import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { UndeliverableMailReportDetails } from '@/modules/Reports';

const UndeliverableMailReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.UNDELIVERABLE_MAIL_REPORT,
      title: 'Undeliverable Mail',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }
  return (
    <Box width="100%" data-testid="undeliverable-mail-report-page">
      <div>
        <Topbar />
      </div>
      <Box>
        <Box margin={{ top: 'spacing24' }}>
          <UndeliverableMailReportDetails />
        </Box>
      </Box>
    </Box>
  );
};

export default UndeliverableMailReportPage;
